import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { ColumnCategoryChart } from 'gnos-charts'

import './style.scss'

@injectIntl
export default class Turnover extends Component {
    static propTypes = {
        data: PropTypes.array,
        intl: PropTypes.object,
    }

    render() {
        const { data, intl } = this.props

        return (
            <div className={'turnover-graph'}>
                <ColumnCategoryChart
                    dataProvider={data}
                    style={{
                        width: '100%',
                        height: '100%',
                        margin: '0 auto',
                        padding: '0px',
                        background: '#ffffff',
                    }}
                    showAxisY
                    intervalText={'-'}
                    texts={{
                        thousand: intl.formatMessage({ id: 'global.thousandShort' }),
                        million: intl.formatMessage({ id: 'global.millionShort' }),
                        billion: intl.formatMessage({ id: 'global.billionShort' }),
                        trillion: intl.formatMessage({ id: 'global.trillionShort' }),
                    }}
                />
            </div>
        )
    }
}
